export type RecoveryBoost = { startsAt: string; endsAt: string; multiplierBasisPoints: number };

/** Integrate server time, including boost boundaries. Overlaps use the largest
 * multiplier, never compound. Remainder stays in base-recovery milliseconds. */
export function boostedRecoveryElapsed(fromMs: number, toMs: number, boosts: readonly RecoveryBoost[]): bigint {
  if (!Number.isSafeInteger(fromMs) || !Number.isSafeInteger(toMs) || toMs < fromMs) throw new Error("Invalid recovery time");
  const ranges = boosts.map(b => ({ from: Date.parse(b.startsAt), to: Date.parse(b.endsAt), bps: b.multiplierBasisPoints }));
  if (ranges.some(b => !Number.isSafeInteger(b.from) || !Number.isSafeInteger(b.to) || b.from >= b.to || !Number.isSafeInteger(b.bps) || b.bps < 10000 || b.bps > 100000)) throw new Error("Invalid recovery boost");
  const points = [...new Set([fromMs, toMs, ...ranges.flatMap(b => [b.from, b.to]).filter(t => t > fromMs && t < toMs)])].sort((a, b) => a - b);
  let numerator = 0n;
  for (let i = 1; i < points.length; i++) {
    const start = points[i - 1]!, end = points[i]!;
    const bps = Math.max(10000, ...ranges.filter(b => b.from <= start && b.to > start).map(b => b.bps));
    numerator += BigInt(end - start) * BigInt(bps);
  }
  // Conservative sub-millisecond rounding; never grants energy early.
  return numerator / 10000n;
}

export function energyRecoveryMultiplier(boosts: readonly RecoveryBoost[], now: number): number {
  return Math.max(10000, ...boosts.filter(b => Date.parse(b.startsAt) <= now && Date.parse(b.endsAt) > now).map(b => b.multiplierBasisPoints));
}
